import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { validityOptions } from '../ariHelpers';
import { selectSx } from './ComponentsStyles';
import { capitalizeSentence } from '../../../../utils/usefulFunctions';
import useTranslate from '../../../../customHooks/useTranslate';

const ValidityFilter = ({ value, label, ...rest }) => {
    const translate = useTranslate();
    const id = 'validity-filter';
    const options = validityOptions.map(option => ({
        ...option,
        text: translate(option.text),
    }));

    const translatedLabel = capitalizeSentence(translate(label));

    return (
        <FormControl sx={selectSx.container}>
            <InputLabel
                id={id}
                sx={{
                    ...selectSx.label,
                    top: '2px',
                }}
            >
                {translatedLabel}
            </InputLabel>
            <Select
                size='small'
                labelId={id}
                id={id}
                value={value}
                sx={selectSx.select}
                {...rest}
            >
                {options.map(option => (
                    <MenuItem
                        sx={selectSx.menuItem}
                        key={option.text}
                        value={option.value}
                    >
                        <div className='flex flex-align-center gap-8'>
                            {option.text}
                        </div>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default ValidityFilter;
